<template>
  <div class="bb-settings-users-panel">
    <div class="bb-tabs">
      <template v-for="tab in tabsList">
        <div
          :key="tab.id"
          class="bb-tabs__item"
          :class="{'bb-tabs__item_active' : activeTab === tab.id}"
          @click="setActiveTab(tab)"
        >
          {{ tab.title }}
        </div>
      </template>
    </div>
    <div class="bb-settings-users-panel-right">
      <div class="bb-settings-users-panel__input-container">
        <input class="bb-settings-users-panel__input-search bb-input bb-input_search"
               type="text"
               @input="inputSearch"
               autocomplete="new-password"
               placeholder="Search">
        <i class="icon-search bb-settings-users-panel__icon-search"/>
      </div>
      <button class="bb-settings-users-panel__btn-new bb-button" @click.stop="createUser()">ADD</button>
    </div>
  </div>
</template>

<script>
import {USERS_LIST_TABS, USER_ACTIVE_TAB_ID} from '@/constants/Tabs/usersListTabs'

export default {
  name: 'SettingsUsersPanel',
  props: {
    tabId: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    tabsList: USERS_LIST_TABS,
    activeTab: USER_ACTIVE_TAB_ID
  }),
  methods: {
    inputSearch (e) {
      this.$emit('inputSearch', e)
    },
    createUser () {
      this.$emit('createUser')
    },
    setActiveTab ({ id }) {
      this.activeTab = id
      this.$emit('update:tabId', id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-settings-users-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__input-container {
      position: relative;
      display: flex;
      align-items: center;
    }

    &__input-search {
      min-width: 578px;
      height: 42px;
    }

    &__icon-search {
      position: absolute;
      left: 12px;
      color: $color-silver;
    }

    &__btn-new {
      width: 73px;
    }
  }

  .bb-settings-users-panel-right {
    display: flex;
    align-items: center;
    grid-gap: 0 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/SettingsUsers/SettingsUsersPanel/SettingsUsersPanel.vue